import React from 'react';
import { useIntl } from 'react-intl';

import { Button } from '@/components/Button';
import type { ContentfulPlaceholderServiceFragment } from '@/graphql/contentful/api';
import { serviceMessages } from '@/messages/service';

import { FormSearch } from '../FormSearch';

import BoutiqueServiceIcon from '@/assets/icons/boutique-service.svg';

export const ServiceDropOff = (props: ContentfulPlaceholderServiceFragment) => {
  const { formatMessage } = useIntl();
  return (
    <FormSearch
      bg='lightGrey'
      data-test-id='ServiceStatusFormSearch'
      icon={BoutiqueServiceIcon}
      {...props}
    >
      <Button>{formatMessage(serviceMessages.findBoutique)}</Button>
    </FormSearch>
  );
};

ServiceDropOff.displayName = 'ServiceDropOff';
